import { createContext, useContext } from 'react'

/* The resource this editor is open on (`Composition/{id}`, `CarePlan/{id}`),
 * threaded from the host's `aiMetadata.resourceRef` prop so it is correct on a
 * node view's FIRST render.
 *
 * The same reference is also on the AI assistant store, but that store is
 * populated from an effect on the host page, which makes it unusable as an
 * identity: it is still null on a cold mount, and across a navigation between
 * two notes for the SAME participant it still names the previous note (the
 * store is deliberately not cleared on that transition, so the assistant does
 * not flicker). Anything keyed by WHICH resource is on screen — the validated
 * tool's draft-store key — must read the reference here. Effect-populated state
 * is fine for consumers that only react to it, which is why
 * `useSuggestionPersistence` keeps reading the store.
 *
 * Null on a bare editor with no host resource; consumers must treat that as
 * "no identity yet" rather than substituting one. */
const EditorResourceContext = createContext<string | null>(null)

export const EditorResourceProvider = EditorResourceContext.Provider

export function useEditorResourceRef(): string | null {
  return useContext(EditorResourceContext)
}
